import { createI18n } from 'vue-i18n'
import messages from '@intlify/unplugin-vue-i18n/messages'
import { getCurrentLanguage } from '@hgj/common-tools'

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'zh-CN',
  fallbackLocale: 'zh-CN',
  availableLocales: ['zh-CN', 'en', 'vi'],
  messages: messages,
})

export function $t(key: string, val?: any) {
  return i18n.global.t(key, val)
}

export function t(key: string, val?: any) {
  return i18n.global.t(key, val)
}

// 加载语言数据
export const loadI18nLanguage = () => {
  // 获取公共头配置的语言
  const lang = getCurrentLanguage()
  setI18nLanguage(lang)
}

/**
 * 设置国际化语言
 * @param locale
 */
export const setI18nLanguage = (locale: any) => {
  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale
  } else {
    i18n.global.locale.value = locale
  }

  const html = document.querySelector('html')
  html?.setAttribute('lang', locale)

  return locale
}
